module.exports = __webpack_public_path__ + "static/media/phone.3cc3201a.svg";